import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import api from "../../services/api";
import dayjs from "dayjs";

const DecoratingConfirmationPage = () => {
  const { bookingId } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const res = await api.get(`/classes/bookings/${bookingId}`);
        setBooking(res.data);
      } catch (err) {
        console.error("Failed to fetch booking", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [bookingId]);

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!booking) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography variant="h6">Booking not found.</Typography>
      </Box>
    );
  }

  const { session, firstName, lastName, email, phone, numSeats } = booking;

  const displayDate = session?.date || booking?.date;
  const displayTime = session
    ? `${session.startTime} – ${session.endTime}`
    : booking?.timeSlot;

  return (
    <Box sx={{ backgroundColor: "#fefefe", py: 8 }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: { xs: 3, sm: 5 }, borderRadius: 3, boxShadow: 3 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            textAlign="center">
            🎉 You're Almost In!
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
            Thank you, {firstName}, for booking your decorating class. We’ve
            noted your e-transfer — we’ll confirm your spot via email shortly.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Booking Summary
          </Typography>

          <Box sx={{ lineHeight: 1.8 }}>
            <Typography>
              <strong>Date:</strong>{" "}
              {session?.date
                ? dayjs(session.date).format("MMMM D, YYYY")
                : "N/A"}
            </Typography>
            <Typography>
              <strong>Time:</strong>{" "}
              {session?.startTime && session?.endTime
                ? `${session.startTime} – ${session.endTime}`
                : "N/A"}
            </Typography>

            <Typography>
              <strong>Number of People:</strong> {numSeats}
            </Typography>
            <Typography>
              <strong>Email:</strong> {email}
            </Typography>
            <Typography>
              <strong>Phone:</strong> {phone}
            </Typography>
          </Box>

          <Box
            sx={{ mt: 4, p: 2, backgroundColor: "#fff9c4", borderRadius: 2 }}>
            <Typography variant="body2" color="text.secondary">
              ⚠️ This session requires a minimum of 5 people. If the group
              doesn’t form, we’ll notify you in advance and refund your payment.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default DecoratingConfirmationPage;
